import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withStyles } from "@mui/styles";
import {getFolderList, getFolders, setSelectedFolders} from '../../../../state/actions/getDataActions';
import {getFilterValues} from '../../../../state/actions/getFilterDataActions';
import {
  addFolder,
  moveFolderItems,
  moveItems,
  removeFoldersAndDeleteItems,
  removeFoldersAndMoveItems,
  removeItems,
  updateFolders
} from '../../../../state/actions/updateDataActions';
import {createdCell, descriptionCell, iconsCell, itemCountCell, nameCell, updatedCell} from './list-view/FolderCells';
import {AddFolderIcon} from '../../../../helpers/Icons'
import {Button,} from '@mui/material';
import DataTable from "../../../util/data-table/DataTable";
import AddFolderDialog from "./AddFolderDialog";
import SelectedFoldersToolbar from "./SelectedFoldersToolbar";
import BindViewOptions from "../../../util/data-table/BindViewOptions";
import {selectCell} from "../items/list-view/ItemCells";

const styles = {
  addButtonMain: {
    padding: '2px 10px 2px 6px',
    borderRadius: '19px',
    backgroundColor: '#ffffff',
    color: "rgba(38, 126, 166, 1)",
    border: "1px solid rgba(38, 126, 166, 0.5)",
    fontSize: '0.7225em',
    '& svg': {
      width: '24px',
      height: '24px',
      marginLeft: '4px',
    }
  }
};

class FoldersExplorer extends Component {
  filterDefinitions = [
    // { label: "Status", key: "status", enabled: true, visible: true, options: (opts) => [{name:'Active', value: 1}, {name: 'Pending', value: 0}] },
    // { label: "Keywords", key: "keywords", enabled: true, visible: true, options: (opts) => opts ? (opts.keywords || []).map((k) => ({value: k.id, name: k.text})) : [] },
    // { label: "People", key: "people", enabled: true, visible: true, options: (opts) => opts ? (opts.people || []).map((p) => ({value: p.id, name: p.name})) : [] },
    // { label: "Folders", key: "folders", enabled: true, visible: true, options: (opts) => opts ? (opts.folders || []).map((f) => ({value: f.id, name: f.name})) : [] },
    // { label: "Emotions", key: "emotions", enabled: true, visible: true, options: (opts) => opts ? (opts.emotions || []).map((e) => ({value: e, name: e})) : [] },
    // { label: "Bemes", key: "bemes", enabled: true, visible: true, options: (opts) => opts ? (opts.bemes || []).map((e) => ({value: e, name: e})) : [] },
    // { label: "Item Types", key: "item_data_types", enabled: true, visible: true, options: (opts) => opts ? (opts.item_data_types || []).map((e) => ({value: e, name: formatItemDataType(e)})) : [] },
    // { label: "File Type", key: "upload_types", enabled: true, visible: true, options: (opts) => opts ? (opts.upload_types || []).map((e) => ({value: e, name: e})) : [] }
  ];

  columns = [
    {key: 'selected', header: {label: '', sort: null }, cell: selectCell, enabled: true},
    {key: 'name', header: { label: 'Folder Name', sort: 'folders.name' }, cell: nameCell, enabled: true },
    {key: 'icons', header: { label: '', sort: null }, cell: iconsCell, enabled: true },
    {key: 'description', header: { label: 'Description', sort: 'folders.description', nulls: true }, cell: descriptionCell, enabled: true },
    {key: 'count', header: { label: 'Items', sort: 'folders.item_count', asc: false }, cell: itemCountCell, enabled: true },
    {key: 'created', header: { label: 'Added', sort: 'folders.created_at', asc: false }, cell: createdCell, enabled: true },
    {key: 'updated', header: { label: 'Modified', sort: 'folders.updated_at', asc: false }, cell: updatedCell, enabled: true },
  ];
  columnMap = Object.fromEntries(this.columns.map(col => [col.key,col]));

  defaultViewOpts = {
    rowsPerPage: 12,
    orders: [{f: 'folders.updated_at', d: false, n: true}],
    viewMode: 'List',
    visibleColumns: Object.assign({}, ...this.columns.filter(col => col.enabled).map(c => ({[c.key]: !c.hidden})))
  };

  defaultFilters = (filters) => [
    // { key: "status", selectedItems: [], },
    // { key: "keywords", selectedItems: [], },
    // { key: "people", selectedItems: [], },
    // { key: "folders", selectedItems: [], },
    // { key: "emotions", selectedItems: [], },
    // { key: "bemes", selectedItems: [], },
    // { key: "item_data_types", selectedItems: [], },
    // { key: "upload_types", selectedItems: [], },
    // { key: "sources", selectedItems: [], },
    { key: "survey_names", selectedItems: [], },
    { key: "survey_complete", selectedItems: [], },
  ];

  state = {
    pageKey: "/explore/folders",
    title: 'Mindfile Folders',
    loading: true,
    viewOptsLoaded: false,
    controller: {
      page: 1,
      rowsPerPage: this.defaultViewOpts.rowsPerPage,
      orders: this.defaultViewOpts.orders,
      search: null,
    },
    mapBounds: null,
    items: [],
    filter_count: 0,
    folderList: [],
    filterSelections: this.defaultFilters(),
    selectedIds: [],
    viewMode: 'List',
    viewModeOptions: ['List'],
    isAddItemDialogOpen: false,
    isViewItemDialogOpen: false,
    addItemType: 'Link',
    isUploadDialogOpen: false,
    isAddFolderDialogOpen: false,
    tableView: {
      addButtons: ['Folder'],
      viewMode: this.defaultViewOpts.viewMode,
      viewModeOptions: ['List'],
      filtersOpen: false,
      columnsOpen: false,
      visibleColumns: this.defaultViewOpts.visibleColumns
    }
  };

  filters = this.filterDefinitions.map((filter, index) => ({
    ...filter, index: index, handleSelect: this.handleFilterSelect.bind(this, index), addFilterSelect: this.addFilterSelect.bind(this, index)
  }));

  renderAddToolbar(type, label){
    return <Button
        id="addButtonMain"
        size="large"
        onClick={() => this.setState({isAddFolderDialogOpen: true})}
        className={this.props.classes.addButtonMain}
        startIcon={<AddFolderIcon />}
        variant="outlined" color="primary"
      >
        Add Folder
      </Button>
  }

  handleFilterSelect(index, selections){
    let newFilters = [...this.state.filterSelections];
    newFilters[index] = {...(newFilters[index]), selectedItems: selections};
    this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelect(index, optionId){
    let newFilters = [...this.state.filterSelections];
    let newSelection = [...newFilters[index].selectedItems];
    if(newSelection.indexOf(optionId) === -1){
      newSelection.push(optionId);
      newFilters[index] = {...(newFilters[index]), selectedItems: newSelection};
      this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
    }
  }

  componentDidMount() {
    this.props.getFolderList(this.props.mindfile.id);
    this.props.getFilterValues(this.props.mindfile.id);
    this.props.setSelectedItems({});
  }

  navFolderView(folderId, e) {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    this.props.history.push(`/explore/folder/${folderId}`);
  }

  closeAddFolderDialog(folderName) {
    this.setState({ isAddFolderDialogOpen: false });
    if(folderName){
      this.props.getFolderList(this.props.mindfile.id, () => {
        this.setState({selectedFolderName: folderName});
      });
    }
  }

  fetchItems(fetchLocations=false) {
    if(!this.props.mindfile.id) return;
    this.setState({loading: true});
    let fetchFilters =  Object.fromEntries(this.filters.map((f,index) => f.enabled ? [f.key, this.state.filterSelections[index].selectedItems] : null).filter(item => !!item));
    this.props.getFolders(this.state.pageKey, this.props.mindfile.id, this.state.controller, fetchFilters, () => {
      if(this.props.mindfileFilterValues.updated) {
        this.props.getFilterValues(this.props.mindfile.id, this.props.mindfileFilterValues.updated);
      }
      this.setState({loading: false});
    });
  }

  handlePageChange(event, page){
    let maxPage = Math.max(1, !this.props.filter_count ? page : Math.ceil(this.props.filter_count / this.state.controller.rowsPerPage));
    let newPage = Math.min(Math.max(1, page), maxPage);
    if(newPage === this.state.controller.page){
      return;
    }
    this.setState({...this.state,
      controller: {
        ...this.state.controller,
        page: newPage
      },
    });
  }

  afterItemsChange(ids){
    let maxPage = Math.max(1, !this.props.filter_count ? this.state.controller.page : Math.ceil((this.props.filter_count - ids.length) / this.state.controller.rowsPerPage));
    if(this.state.controller.page > maxPage){
      this.handlePageChange(null, maxPage);
    }else{
      this.fetchItems();
    }
  }

  handleDeleteSelectedAndDeleteItems(ids){
    // const ids = this.state.selectedIds;
    this.setState({loading: true});
    this.props.removeFoldersAndDeleteItems(ids, this.afterItemsChange.bind(this));
  }

  handleDeleteSelectedAndMoveItems(ids, destId){
    this.setState({loading: true});
    this.props.removeFoldersAndMoveItems(ids, destId, this.afterItemsChange.bind(this));
  }

  handleMoveSelected(ids, destId){
    this.setState({loading: true});
    this.props.moveFolderItems(ids, destId, () => {
      this.afterItemsChange([])
    });
  }

  handleSaveFolders(folders){
    this.setState({loading: true});
    this.props.updateFolders(folders, (updated) => this.afterItemsChange([]));
  }

  handleChangeRowsPerPage(event){
    const newRows = parseInt(event.target.value);
    let itemFirst = Math.max(0, ((this.state.controller.page - 1) * this.state.controller.rowsPerPage) + 1);
    if(!!this.props.filter_count){
      itemFirst = Math.min(this.props.filter_count, itemFirst);
    }
    const page = Math.floor(itemFirst / newRows) + 1;
    let maxPage = Math.max(1, !this.props.filter_count ? page : Math.ceil(this.props.filter_count /newRows));
    let newPage = Math.min(Math.max(1, page), maxPage);
    this.setState((prevState, props) => ({controller: {
      ...prevState.controller,
      rowsPerPage: newRows,
      page: newPage
    }}));
  }

  render() {
    if(this.props.mindfileUserLevel > 2){
      if(this.columns[0].key === "selected") {
        this.columns[0].enabled = false;
      }
      // if(this.filters.length > 0 && this.filters[0].key === "status"){
        // this.filters[0].visible = false;
        // this.filterSelections[0] = { key: "status", selectedItems: [1], };
      // }
    }
    return (
      <>
        <div style={{position:'relative', display: 'flex', flexDirection:'row', flexWrap:'wrap-reverse', alignItems: 'center', margin: '0 0 1rem', gap: '0.5em 0'}}>
          { this.props.mindfileUserLevel <= 2 ?
            <div style={{flexGrow:0, flexShrink:0, whiteSpace: 'nowrap', marginRight:'1em'}}>
              {this.renderAddToolbar()}
            </div>
            : <div style={{flexGrow:146, flexShrink:1, maxWidth: '162px', minWidth:'0px'}}/>
          }
          <div style={{flexGrow:1}}>
            <h2 id="pageTitle" style={{textAlign: 'center', fontWeight: '400', wordBreak:'break-word', margin: '0 auto'}}>{this.state.title}</h2>
          </div>
          <div style={{flexGrow:146, flexShrink:1, maxWidth: '162px', minWidth:'0px'}}/>
        </div>
        <DataTable
          mindfileId={this.props.mindfile.id}
          itemList={this.props.itemsKey !== this.state.pageKey ? [] : this.props.folders || []}
          itemCount={this.props.itemsKey !== this.state.pageKey ? 0 : this.props.filter_count}
          itemMap={this.props.itemsKey !== this.state.pageKey ? {} : this.props.itemMap || []}
          fetchItems={this.fetchItems.bind(this)}
          folderList={this.props.folderList}
          addFolder={this.props.addFolder}
          removeItems={this.props.removeItems.bind(this)}
          moveItems={this.props.moveItems.bind(this)}
          columns={this.columns}
          columnMap={this.columnMap}
          filters={this.filters}
          filterSelections={this.state.filterSelections}
          clearFilterSelections={() => this.setState({filterSelections: this.defaultFilters()})}
          mindfileFilterValues={this.props.mindfileFilterValues}
          controller={this.state.controller}
          setController={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevStateFunc(prevState, props)}})
            })
          }}
          mapBounds={this.state.mapBounds}
          setMapBounds={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevState.controller, page: 1}, mapBounds: prevStateFunc(prevState, props)})
            })
          }}
          loading={this.state.loading}
          setLoading={(isLoading) => this.setState({loading: isLoading})}
          viewOptsLoaded={this.state.viewOptsLoaded}
          bindViewOptions={
            <BindViewOptions
              pageKey={this.state.pageKey}
              parentState={this.state}
              parentProps={this.props}
              setParentState={this.setState.bind(this)}
              defaultViewOpts={this.defaultViewOpts}
              loaded={this.state.viewOptsLoaded}
              setLoaded={loaded => this.setState({viewOptsLoaded: loaded})}
            />
          }
          openDataView={this.navFolderView.bind(this)}
          tableToolbar={[]}
          selectedToolbar={(
            <SelectedFoldersToolbar
              selectedItems={this.props.selectedItems}
              setSelectedItems={this.props.setSelectedItems}
              folders={this.props.folders || []}
              folderList={this.props.folderList}
              addFolder={this.props.addFolder}
              handleMoveSelected={this.handleMoveSelected.bind(this)}
              handleDeleteSelectedAndDeleteItems={this.handleDeleteSelectedAndDeleteItems.bind(this)}
              handleDeleteSelectedAndMoveItems={this.handleDeleteSelectedAndMoveItems.bind(this)}
              handleSaveFolders={this.handleSaveFolders.bind(this)}
              controller={this.state.controller}
              itemCount={this.props.filter_count}
              pageItemCount={this.props.folders.length}
              handlePageChange={this.handlePageChange.bind(this)}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
              mindfileUserLevel={this.props.mindfileUserLevel}
            />
          )}

          viewMode={this.state.tableView.viewMode}
          setViewMode={(e) => this.setState({tableView: {...this.state.tableView, viewMode: e.target.value}})}
          viewModeOptions={this.state.tableView.viewModeOptions}
          filtersOpen={this.state.tableView.filtersOpen}
          setFiltersOpen={(open) => this.setState({tableView: {...this.state.tableView, filtersOpen: open}})}
          columnsOpen={this.state.tableView.columnsOpen}
          setColumnsOpen={(open) => this.setState({tableView: {...this.state.tableView, columnsOpen: open}})}
          visibleColumns={this.state.tableView.visibleColumns}
          setVisibleColumns={(columns) => this.setState({tableView: {...this.state.tableView, visibleColumns: columns}})}
          mindfileUserLevel={this.props.mindfileUserLevel}
          selectedIds={this.props.mindfileUserLevel > 2 ? [] : this.state.selectedIds}
          setSelectedIds={this.props.mindfileUserLevel > 2 ? null : (ids) => this.setState({selectedIds: ids})}
          selectedItems={this.props.mindfileUserLevel > 2 ? {} : this.props.selectedItems}
          setSelectedItems={this.props.mindfileUserLevel > 2 ? null : this.props.setSelectedItems.bind(this)}
        />
        <AddFolderDialog
          id="addFolderDialog"
          isOpen={this.state.isAddFolderDialogOpen}
          closeDialog={this.closeAddFolderDialog.bind(this)}
          addFolder={(name, desc) => this.props.addFolder(name, desc, () => this.fetchItems())} />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    itemsKey: state.folders?.pageKey,
    folders: state.folders?.folders || [],
    filter_count: state.folders?.filter_count || 0,
    itemMap: !!state.folders && !! state.folders.folders ? Object.fromEntries(state.folders.folders.map((item) => [item.id, item])) : {},
    canEdit: state.isCurrentMindfileContributor,
    mindfile: state.mindfile,
    folderList: state.folderList,
    mindfileFilterValues: state.mindfileFilterValues,
    selectedItems: state.selectedFolders,
    mindfileUserLevel: state.mindfileUserLevel.level,
    // isAdmin: state.auth.is_admin,
    // isCurrentMindfileOwner: state.isCurrentMindfileOwner || state.auth.is_admin,
    // isCurrentMindfileContributor: state.isCurrentMindfileContributor || state.isCurrentMindfileOwner || state.auth.is_admin ,
  };
}

const setSelectedItems = setSelectedFolders;
const mapDispatchToProps = {
  getFolderList,
  getFolders,
  addFolder,
  removeItems,
  moveItems,
  removeFoldersAndDeleteItems,
  removeFoldersAndMoveItems,
  moveFolderItems,
  updateFolders,
  getFilterValues,
  setSelectedItems
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FoldersExplorer));
